module.exports = __webpack_public_path__ + "static/img/erweima.b2ab6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/assets/img/erweima.jpg
// module id = w+XS
// module chunks = 1